/* eslint-disable react/prop-types */
import { Button } from '@mui/material';
import React from 'react';
import './common.scss'

const ActionButton = ({ id="", onClick = () => { }, sx, disabled = false,textLabel = '', className='', type='button'}) =>
    <Button id={ id} disabled={disabled} type={type} sx={sx} className={`btn-action ${className}`} onClick={onClick}>{textLabel}</Button>;

export default ActionButton;